export const UTILITY_ACTIVATION_STATUS_PENDING = 'pending';
export const UTILITY_ACTIVATION_STATUS_MISSING_PROVIDER = 'missingProvider';
export const UTILITY_ACTIVATION_STATUS_COMPLETED = 'completed';
export const UTILITY_ACTIVATION_STATUS_CANCELED = 'canceled';

export const UTILITY_ACTIVATION_STATUS_LIST = [
  UTILITY_ACTIVATION_STATUS_PENDING,
  UTILITY_ACTIVATION_STATUS_MISSING_PROVIDER,
  UTILITY_ACTIVATION_STATUS_COMPLETED,
  UTILITY_ACTIVATION_STATUS_CANCELED,
];

export const UTILITY_ACTIVATION_STATUS_CANCEL_REASON_OTHER = 'other';
export const UTILITY_ACTIVATION_STATUS_CANCEL_REASON_CHANGED_LISTING = 'changedListing';
export const UTILITY_ACTIVATION_STATUS_CANCEL_REASON_CHANGED_TENANT = 'changedTenant';
export const UTILITY_ACTIVATION_STATUS_CANCEL_REASON_CHANGED_ADDRESS = 'changedAddress';

export const UTILITY_ACTIVATION_STATUS_CANCEL_REASON_LIST = [
  UTILITY_ACTIVATION_STATUS_CANCEL_REASON_OTHER,
  UTILITY_ACTIVATION_STATUS_CANCEL_REASON_CHANGED_LISTING,
  UTILITY_ACTIVATION_STATUS_CANCEL_REASON_CHANGED_TENANT,
  UTILITY_ACTIVATION_STATUS_CANCEL_REASON_CHANGED_ADDRESS,
];

export const UTILITY_ACTIVATION_SOURCE_SIGNUP = 'signup';
export const UTILITY_ACTIVATION_SOURCE_LAZY_SIGNUP = 'lazySignup';
export const UTILITY_ACTIVATION_SOURCE_BULK_IMPORT = 'bulkImport';
export const UTILITY_ACTIVATION_SOURCE_API_HANDLER = 'apiHandler';
export const UTILITY_ACTIVATION_SOURCE_BCC_REMINDER = 'bccReminder';
export const UTILITY_ACTIVATION_SOURCE_PARTNER_REMINDER = 'partnerReminder';

export const UTILITY_ACTIVATION_ITEM_STATUS_MISSING_PROVIDER = 'missingProvider';
export const UTILITY_ACTIVATION_ITEM_STATUS_SETUP_COMPLETED = 'setupCompleted';
export const UTILITY_ACTIVATION_ITEM_STATUS_ACCOUNT_REQUESTED = 'accountRequested';
export const UTILITY_ACTIVATION_ITEM_STATUS_COMPLETED = 'completed';
export const UTILITY_ACTIVATION_ITEM_STATUS_DROPOUT = 'dropout';

export const UTILITY_ACTIVATION_ITEM_STATUS_LIST = [
  UTILITY_ACTIVATION_ITEM_STATUS_MISSING_PROVIDER,
  UTILITY_ACTIVATION_ITEM_STATUS_SETUP_COMPLETED,
  UTILITY_ACTIVATION_ITEM_STATUS_ACCOUNT_REQUESTED,
  UTILITY_ACTIVATION_ITEM_STATUS_COMPLETED,
  UTILITY_ACTIVATION_ITEM_STATUS_DROPOUT,
];

export const UTILITY_ACTIVATION_ITEM_DROPOUT_REASON_ACCOUNT_TRANSFER = 'accountTransfer';
export const UTILITY_ACTIVATION_ITEM_DROPOUT_REASON_BOOKED_DIRECTLY = 'bookedDirectly';
export const UTILITY_ACTIVATION_ITEM_DROPOUT_REASON_OTHER_PROVIDER = 'otherProvider';
export const UTILITY_ACTIVATION_ITEM_DROPOUT_REASON_DECLINED_TO_PURCHASE =
  'renterDeclinedToPurchase';
export const UTILITY_ACTIVATION_ITEM_DROPOUT_REASON_UTILITY_PART_OF_RENT = 'utilityPartOfRent';
export const UTILITY_ACTIVATION_ITEM_DROPOUT_REASON_PROVIDER_MAPPING_ERROR = 'providerMappingError';
export const UTILITY_ACTIVATION_ITEM_DROPOUT_REASON_PARTNER_MARKED_PURCHASED_OUTSIDE =
  'partnerMarkedPurchasedOutside'; // eslint-disable-line max-len
export const UTILITY_ACTIVATION_ITEM_DROPOUT_REASON_PROPERTY_SINGLE_PROVIDER =
  'propertyWiredForSingleInternetProvider'; // eslint-disable-line max-len
export const UTILITY_ACTIVATION_ITEM_DROPOUT_REASON_OTHER = 'other';

export const UTILITY_ACTIVATION_ITEM_RENTER_DROPOUT_REASON_LIST = [
  UTILITY_ACTIVATION_ITEM_DROPOUT_REASON_ACCOUNT_TRANSFER,
  UTILITY_ACTIVATION_ITEM_DROPOUT_REASON_BOOKED_DIRECTLY,
  UTILITY_ACTIVATION_ITEM_DROPOUT_REASON_OTHER_PROVIDER,
  UTILITY_ACTIVATION_ITEM_DROPOUT_REASON_PARTNER_MARKED_PURCHASED_OUTSIDE,
];

export const UTILITY_ACTIVATION_ITEM_DROPOUT_REASON_LIST = [
  UTILITY_ACTIVATION_ITEM_DROPOUT_REASON_ACCOUNT_TRANSFER,
  UTILITY_ACTIVATION_ITEM_DROPOUT_REASON_BOOKED_DIRECTLY,
  UTILITY_ACTIVATION_ITEM_DROPOUT_REASON_DECLINED_TO_PURCHASE,
  UTILITY_ACTIVATION_ITEM_DROPOUT_REASON_UTILITY_PART_OF_RENT,
  UTILITY_ACTIVATION_ITEM_DROPOUT_REASON_PROVIDER_MAPPING_ERROR,
  UTILITY_ACTIVATION_ITEM_DROPOUT_REASON_PROPERTY_SINGLE_PROVIDER,
  UTILITY_ACTIVATION_ITEM_DROPOUT_REASON_OTHER,
];

export const UTILITY_PROVIDERS_MILES_RANGE = 5;

export const UTILITY_PROVIDER_SOURCE_SYSTEM = 'system';
export const UTILITY_PROVIDER_SOURCE_PARTNER = 'partner';
export const UTILITY_PROVIDER_SOURCE_STAFF = 'staff';
export const UTILITY_PROVIDER_SOURCE_UNKNOWN = 'unknown';
export const UTILITY_PROVIDER_SOURCE_TENANT = 'tenant';

export const UTILITY_PROVIDER_OTHER_ID = 'other';

export const UTILITY_PROVIDER_SOURCE_LIST = [
  UTILITY_PROVIDER_SOURCE_SYSTEM,
  UTILITY_PROVIDER_SOURCE_PARTNER,
  UTILITY_PROVIDER_SOURCE_STAFF,
  UTILITY_PROVIDER_SOURCE_UNKNOWN,
  UTILITY_PROVIDER_SOURCE_TENANT,
];

export const UTILITY_PROVIDER_SOURCE_REQUIRE_USER_ID = [
  UTILITY_PROVIDER_SOURCE_PARTNER,
  UTILITY_PROVIDER_SOURCE_STAFF,
];

export const UTILITY_PROVIDER_TYPE_LINK = 'link';
export const UTILITY_PROVIDER_TYPE_PLANS = 'plans';
export const UTILITY_PROVIDER_TYPE_INSURANCE_PLANS = 'insuranceplans';
export const UTILITY_PROVIDER_TYPE_PENDING_SETUP = 'pendingSetup';

export const INSURANCE_POLICY_SOURCE_BEAGLE = 'beagle';
export const INSURANCE_POLICY_SOURCE_OTHER = 'other';

export const INSURANCE_POLICY_STATUS_PENDING = 'pending';
export const INSURANCE_POLICY_STATUS_ACTIVE = 'active';
export const INSURANCE_POLICY_STATUS_CANCELLED = 'cancelled';

export const UTILITY_PROVIDER_MAPPING_ACTION_MAPPED = 'mapped';
export const UTILITY_PROVIDER_MAPPING_ACTION_UNMAPPED = 'unmapped';

export const UTILITY_PROVIDER_MAPPING_USER_TYPE_RENTER = 'renter';
export const UTILITY_PROVIDER_MAPPING_USER_TYPE_PARTNER = 'partner';
export const UTILITY_PROVIDER_MAPPING_USER_TYPE_ADMIN = 'admin';
export const UTILITY_PROVIDER_MAPPING_USER_TYPE_SYSTEM = 'system';
export const UTILITY_PROVIDER_MAPPING_USER_TYPE_AUTO_MAPPING = 'autoMapping';
export const UTILITY_PROVIDER_MAPPING_USER_TYPE_SERVICE_AREA = 'serviceArea';

export const UTILITY_ACTIVATION_UI_STATE_PENDING = 'pending';
export const UTILITY_ACTIVATION_UI_STATE_WAITING = 'waiting';
export const UTILITY_ACTIVATION_UI_STATE_COMPLETED = 'completed';
export const UTILITY_ACTIVATION_UI_STATE_WARNING = 'warning';
export const UTILITY_ACTIVATION_UI_STATE_NOT_REQUIRED = 'notRequired';

export const UTILITY_ACTIVATION_UI_STATE_TO_COLOR_MAPPING = {
  [UTILITY_ACTIVATION_UI_STATE_PENDING]: 'orange300',
  [UTILITY_ACTIVATION_UI_STATE_WAITING]: 'orange300',
  [UTILITY_ACTIVATION_UI_STATE_COMPLETED]: 'green',
  [UTILITY_ACTIVATION_UI_STATE_WARNING]: 'yellowSunrise300',
  [UTILITY_ACTIVATION_UI_STATE_NOT_REQUIRED]: 'greyMonochromeInactive',
};

export const UTILITY_ACTIVATION_UI_STATE_TO_ICON_MAPPING = {
  [UTILITY_ACTIVATION_UI_STATE_PENDING]: '/images/circle-orange-empty.svg',
  [UTILITY_ACTIVATION_UI_STATE_WAITING]: '/images/clock-orange.svg',
  [UTILITY_ACTIVATION_UI_STATE_COMPLETED]: '/images/checkmark-circle-green.svg',
  [UTILITY_ACTIVATION_UI_STATE_WARNING]: '/images/exclamation-circle-yellow.svg',
  [UTILITY_ACTIVATION_UI_STATE_NOT_REQUIRED]: '/images/inactive-circle.svg',
};

export const UTILITY_LOGIN_PROVIDER_PARTNER_FORM = 'utilityLoginPartnerForm';

export const UTILITY_TYPE_ID_INTERNET = 1;
export const UTILITY_TYPE_ID_ELECTRICITY = 2;
export const UTILITY_TYPE_ID_WATER = 3;
export const UTILITY_TYPE_ID_GAS = 4;
export const UTILITY_TYPE_ID_TRASH = 5;
export const UTILITY_TYPE_ID_SEWER = 6;
export const UTILITY_TYPE_ID_LIABILITY_INSURANCE = 7;

export const UTILITY_PROVIDER_ID_SPECTRUM = 4;
export const UTILITY_PROVIDER_ID_XFINITY = 5;
export const UTILITY_PROVIDER_ID_ATT = 1; // AT&T Fiber

export const UTILITY_PROVIDER_ID_RELIANT = 318;
export const UTILITY_PROVIDER_ID_GAS_SOUTH = 54;

export const UTILITY_PROVIDER_BLOCKED_MANUAL_MAPPING_IDS = [597, 1778];
export const UTILITY_PROVIDER_BLOCKED_MANUAL_MAPPING_NAMES = {
  597: 'Energy Texas',
  1778: 'Rhythm',
};

export const UTILITY_MAX_ORDERS_PER_SALES_REP = 20;

export const UTILITY_AUTO_MAPPING_CONFIDENCE_PROVIDER_THRESHOLD = 95;

export const UTILITY_PROPERTY_MANAGEMENT_SOFTWARE_APPFOLIO_ID = 1;
export const UTILITY_PROPERTY_MANAGEMENT_SOFTWARE_RENTVINE_ID = 10;
export const UTILITY_PROPERTY_MANAGEMENT_SOFTWARE_OTHER_ID = 15;

export const UTILITY_PARTNER_STATUS_PENDING_DEMO = 'pendingDemo';
export const UTILITY_PARTNER_STATUS_ONBOARDED = 'onboarded';
export const UTILITY_PARTNER_STATUS_ACTIVE = 'active';
export const UTILITY_PARTNER_STATUS_CHURNED = 'churned';
export const UTILITY_PARTNER_STATUS_ARCHIVED = 'archived';

export const UTILITY_PARTNER_CUSTOMER_TYPE_PROPERTY_MANAGER = 'propertyManager';
export const UTILITY_PARTNER_CUSTOMER_TYPE_PLATFORM = 'platform';
export const UTILITY_PARTNER_CUSTOMER_TYPE_TENANT_SCREENING = 'tenantScreening';
export const UTILITY_PARTNER_CUSTOMER_TYPE_HOMEBUYER = 'homebuyer';
export const UTILITY_PARTNER_CUSTOMER_TYPE_DIRECT_TO_CONSUMER = 'directToConsumer';

export const UTILITY_PARTNER_CUSTOMER_TYPE_LIST = [
  UTILITY_PARTNER_CUSTOMER_TYPE_PROPERTY_MANAGER,
  UTILITY_PARTNER_CUSTOMER_TYPE_PLATFORM,
  UTILITY_PARTNER_CUSTOMER_TYPE_TENANT_SCREENING,
  UTILITY_PARTNER_CUSTOMER_TYPE_HOMEBUYER,
  UTILITY_PARTNER_CUSTOMER_TYPE_DIRECT_TO_CONSUMER,
];

export const UTILITY_PARTNER_CUSTOMER_TYPE_LABELS = {
  [UTILITY_PARTNER_CUSTOMER_TYPE_PROPERTY_MANAGER]: 'Property Manager',
  [UTILITY_PARTNER_CUSTOMER_TYPE_PLATFORM]: 'Platform',
  [UTILITY_PARTNER_CUSTOMER_TYPE_TENANT_SCREENING]: 'Tenant Screening',
  [UTILITY_PARTNER_CUSTOMER_TYPE_HOMEBUYER]: 'Homebuyer',
  [UTILITY_PARTNER_CUSTOMER_TYPE_DIRECT_TO_CONSUMER]: 'Direct to Consumer',
};

export const UTILITY_ACTIVATION_HOUSING_TYPE_RENTER = 'renter';
export const UTILITY_ACTIVATION_HOUSING_TYPE_HOMEOWNER = 'homeowner';
export const UTILITY_ACTIVATION_HOUSING_TYPE_TITLE = 'title';

// `homeowner` reads as "Home Buyer" — that is how the support team refers to
// direct-to-consumer purchase customers.
export const UTILITY_ACTIVATION_HOUSING_TYPE_LABELS = {
  [UTILITY_ACTIVATION_HOUSING_TYPE_RENTER]: 'Renter',
  [UTILITY_ACTIVATION_HOUSING_TYPE_HOMEOWNER]: 'Home Buyer',
  [UTILITY_ACTIVATION_HOUSING_TYPE_TITLE]: 'Title',
};

export const UTILITY_PARTNER_DEFAULT_HOUSING_TYPE_HOMEOWNER = 'homeowner';
export const UTILITY_PARTNER_DEFAULT_HOUSING_TYPE_RENTER = 'renter';

export const UTILITY_PARTNER_DEFAULT_HOUSING_TYPE_LIST = [
  UTILITY_PARTNER_DEFAULT_HOUSING_TYPE_HOMEOWNER,
  UTILITY_PARTNER_DEFAULT_HOUSING_TYPE_RENTER,
];

export const PARTNER_ADDRESS_STATUS_LISTED = 'listed';
export const PARTNER_ADDRESS_STATUS_UNLISTED = 'unlisted';
export const PARTNER_ADDRESS_STATUS_WITHDRAWN = 'withdrawn';
export const PARTNER_ADDRESS_STATUS_LEASED = 'leased';
export const PARTNER_ADDRESS_STATUS_ARCHIVED = 'archived';
export const PARTNER_ADDRESS_STATUS_PENDING_VERIFICATION = 'pendingVerification';
export const PARTNER_ADDRESS_STATUS_NA = 'n/a';

export const PARTNER_ADDRESS_SOURCE_ACTIVE_TENANT_IMPORT = 'activeTenantImport';
export const PARTNER_ADDRESS_SOURCE_SCRAPER = 'scraper';
export const PARTNER_ADDRESS_SOURCE_PARTNER = 'partner';
export const PARTNER_ADDRESS_SOURCE_ADMIN = 'admin';
export const PARTNER_ADDRESS_SOURCE_SUNROOM = 'sunroom';
export const PARTNER_ADDRESS_SOURCE_RENT_ROLL = 'rentRoll';
export const PARTNER_ADDRESS_SOURCE_NA = 'n/a';
export const PARTNER_ADDRESS_SOURCE_BULK_IMPORT = 'bulkImport';
export const PARTNER_ADDRESS_SOURCE_PMS_SYNC = 'pmsSync';
export const PARTNER_ADDRESS_SOURCE_LINK = 'link';
export const PARTNER_ADDRESS_SOURCE_TENANT_SCREENING_SEARCH = 'tenantScreeningSearch';
export const PARTNER_ADDRESS_SOURCE_PARTNER_MANUAL_ADDITION = 'partnerManualAddition';

export const UTILITY_COVERAGE_POINT_VERIFICATION_METHOD_CALL = 'call';
export const UTILITY_COVERAGE_POINT_VERIFICATION_METHOD_WEBSITE = 'website';
export const UTILITY_COVERAGE_POINT_VERIFICATION_METHOD_NEARBY_PROVIDER = 'nearbyProvider';
export const UTILITY_COVERAGE_POINT_VERIFICATION_METHOD_DEFAULT_CITY_MAPPING = 'defaultCityMapping';
export const UTILITY_COVERAGE_POINT_VERIFICATION_METHOD_SERVICE_AREA_MAPPING = 'serviceAreaMapping';
export const UTILITY_COVERAGE_POINT_VERIFICATION_METHOD_OTHER = 'other';

export const UTILITY_COVERAGE_POINT_VERIFICATION_METHOD_EDITABLE_LIST = [
  UTILITY_COVERAGE_POINT_VERIFICATION_METHOD_WEBSITE,
  UTILITY_COVERAGE_POINT_VERIFICATION_METHOD_CALL,
  UTILITY_COVERAGE_POINT_VERIFICATION_METHOD_DEFAULT_CITY_MAPPING,
  UTILITY_COVERAGE_POINT_VERIFICATION_METHOD_NEARBY_PROVIDER,
  UTILITY_COVERAGE_POINT_VERIFICATION_METHOD_SERVICE_AREA_MAPPING,
  UTILITY_COVERAGE_POINT_VERIFICATION_METHOD_OTHER,
];

export const UTILITY_COVERAGE_POINT_VERIFICATION_OUTCOME_VERIFIED = 'verified';
export const UTILITY_COVERAGE_POINT_VERIFICATION_OUTCOME_OTHER = 'other';

export const UTILITY_COVERAGE_POINT_VERIFICATION_OUTCOME_LIST = [
  UTILITY_COVERAGE_POINT_VERIFICATION_OUTCOME_VERIFIED,
  UTILITY_COVERAGE_POINT_VERIFICATION_OUTCOME_OTHER,
];

export const UTILITY_PARTNER_ID_BASELANE = 991;

export const UTILITY_PARTNER_GROUP_ID_RELIANT = 19;

export const PARTNER_ADDRESS_STAGE_TENANT_REQUESTED = 6;
export const PARTNER_ADDRESS_STAGE_PARTNER_ADDED = 5;
export const PARTNER_ADDRESS_STAGE_LISTING_LEASED = 4;
export const PARTNER_ADDRESS_STAGE_LISTING_UNLISTED = 3;
export const PARTNER_ADDRESS_STAGE_LISTING_LISTED = 2;
export const PARTNER_ADDRESS_STAGE_PLATFORM_LISTING_LISTED = 1;
export const PARTNER_ADDRESS_STAGE_NA = 0;
export const PARTNER_ADDRESS_STAGE_HOMEBUYER_LISTING_LISTED = 7;

export const PARTNER_ADDRESS_STAGES_LIST = [
  PARTNER_ADDRESS_STAGE_TENANT_REQUESTED,
  PARTNER_ADDRESS_STAGE_PARTNER_ADDED,
  PARTNER_ADDRESS_STAGE_LISTING_LEASED,
  PARTNER_ADDRESS_STAGE_LISTING_UNLISTED,
  PARTNER_ADDRESS_STAGE_LISTING_LISTED,
  PARTNER_ADDRESS_STAGE_PLATFORM_LISTING_LISTED,
  PARTNER_ADDRESS_STAGE_NA,
  PARTNER_ADDRESS_STAGE_HOMEBUYER_LISTING_LISTED,
];

export const PARTNER_ADDRESS_STAGE_TO_LABEL_MAPPING = {
  [PARTNER_ADDRESS_STAGE_TENANT_REQUESTED]: 'Tenant Requested',
  [PARTNER_ADDRESS_STAGE_PARTNER_ADDED]: 'Partner Added',
  [PARTNER_ADDRESS_STAGE_LISTING_LEASED]: 'Listing Leased',
  [PARTNER_ADDRESS_STAGE_LISTING_UNLISTED]: 'Listing Unlisted',
  [PARTNER_ADDRESS_STAGE_LISTING_LISTED]: 'Listing Listed',
  [PARTNER_ADDRESS_STAGE_PLATFORM_LISTING_LISTED]: 'Platform Listing Listed',
  [PARTNER_ADDRESS_STAGE_NA]: 'Listing N/A',
  [PARTNER_ADDRESS_STAGE_HOMEBUYER_LISTING_LISTED]: 'Homebuyer Listing Listed',
};

export const PARTNER_ADDRESS_LEASE_TYPE_SHORT_TERM = 'shortTerm';
export const PARTNER_ADDRESS_LEASE_TYPE_LONG_TERM = 'longTerm';
export const PARTNER_ADDRESS_LEASE_TYPE_LEASE_ONLY = 'leaseOnly';

export const PARTNER_ADDRESS_LEASE_TYPES = [
  PARTNER_ADDRESS_LEASE_TYPE_LONG_TERM,
  PARTNER_ADDRESS_LEASE_TYPE_SHORT_TERM,
  PARTNER_ADDRESS_LEASE_TYPE_LEASE_ONLY,
];

export const PARTNER_ADDRESS_LEASE_TYPE_TO_LABEL_MAPPING = {
  [PARTNER_ADDRESS_LEASE_TYPE_LONG_TERM]: 'Normal long-term lease (some utilities needed)',
  [PARTNER_ADDRESS_LEASE_TYPE_SHORT_TERM]: 'Short-term lease (no utilities needed)',
  [PARTNER_ADDRESS_LEASE_TYPE_LEASE_ONLY]: 'Lease-only, no management (no utilities needed)',
};

export const LISTING_SCRAPER_LOG_STATUS_SUCCESS = 'success';
export const LISTING_SCRAPER_LOG_STATUS_FAILED = 'failed';

export const LISTING_SCRAPER_FEED_STATUS_PENDING = 'pending';
export const LISTING_SCRAPER_FEED_STATUS_ACTIVE = 'active';
export const LISTING_SCRAPER_FEED_STATUS_DISABLED = 'disabled';

export const UTILITY_ADDRESS_SEARCH_STATUS_SUCCESS = 'success';
export const UTILITY_ADDRESS_SEARCH_STATUS_FAILED = 'failed';

export const UTILITY_ADDRESS_SEARCH_STATUS_LIST = [
  UTILITY_ADDRESS_SEARCH_STATUS_SUCCESS,
  UTILITY_ADDRESS_SEARCH_STATUS_FAILED,
];

export const UTILITY_PARTNER_ADDRESS_DOC_TYPE_REQUIRED_BY_UTILITY = 'requiredByUtility';

export const UTILITY_INTERNET_RENTING_MODEM_YES = 'yes';
export const UTILITY_INTERNET_RENTING_MODEM_NO = 'no';
export const UTILITY_INTERNET_LESS_THAN_6MONTHS_YES = 'yes';
export const UTILITY_INTERNET_LESS_THAN_6MONTHS_NO = 'no';

export const UTILITY_HOUSEHOLD_STATUS_ACTIVE = 'active';
export const UTILITY_HOUSEHOLD_STATUS_ARCHIVED = 'archived';

export const UTILITY_INVOICE_STATUS_PENDING_PAYMENT = 'pendingPayment';
export const UTILITY_INVOICE_STATUS_PAID = 'paid';
export const UTILITY_INVOICE_STATUS_CANCELLED = 'cancelled';

export const UTILITY_INVOICE_STATUS_LIST = [
  UTILITY_INVOICE_STATUS_PENDING_PAYMENT,
  UTILITY_INVOICE_STATUS_PAID,
  UTILITY_INVOICE_STATUS_CANCELLED,
];

export const UTILITY_PAYOUT_STATUS_PENDING_PAYMENT = 'pendingPayment';
export const UTILITY_PAYOUT_STATUS_TRANSFER_INITIATED = 'transferInitiated';
export const UTILITY_PAYOUT_STATUS_PAID = 'paid';
export const UTILITY_PAYOUT_STATUS_CANCELLED = 'cancelled';

export const UTILITY_PAYOUT_STATUS_LIST = [
  UTILITY_PAYOUT_STATUS_PENDING_PAYMENT,
  UTILITY_PAYOUT_STATUS_PAID,
  UTILITY_PAYOUT_STATUS_CANCELLED,
];

export const UTILITY_SELF_ONBOARDING_STEP_USER = 'User';
export const UTILITY_SELF_ONBOARDING_STEP_BRAND = 'Brand';
export const UTILITY_SELF_ONBOARDING_STEP_SYNC = 'Sync';
export const UTILITY_SELF_ONBOARDING_STEP_CONNECT = 'Connect';
export const UTILITY_SELF_ONBOARDING_STEP_EMAIL = 'Email';
export const UTILITY_SELF_ONBOARDING_STEP_INTRO = 'Intro';
export const UTILITY_SELF_ONBOARDING_STEP_INVITE_TEAM = 'Invite Team';

export const UTILITY_TENANT_BULK_IMPORT_SYNC_STATUS_PENDING = 'pending';
export const UTILITY_TENANT_BULK_IMPORT_SYNC_STATUS_COMPLETED = 'completed';
export const UTILITY_TENANT_BULK_IMPORT_SYNC_STATUS_FAILED = 'failed';
export const UTILITY_TENANT_BULK_IMPORT_SYNC_STATUS_OUTDATED = 'outdated';

export const UTILITY_BULK_IMPORT_SOURCE_ADMIN_UPLOAD = 'adminUpload';

export const UTILITY_ACTIVATION_FEEDBACK_TAGS_LOW_RATING = [
  'Not Accurate Info',
  'Bad Support',
  'Not Clear Instructions',
  'I Don’t Trust It',
  'Utilities Not Required',
  'Broken Links',
];

export const UTILITY_ACTIVATION_FEEDBACK_TAGS_HIGH_RATING = [
  'Accurate Info',
  'Good Support',
  'Clear Instructions',
  'Easy to Use',
  'Convenient',
  'Empowering',
];

export const UTILITY_ACTIVATION_LINK_REQUEST_STATUS_PENDING = 'pending';
export const UTILITY_ACTIVATION_LINK_REQUEST_STATUS_ERROR = 'error';
export const UTILITY_ACTIVATION_LINK_REQUEST_STATUS_COMPLETED = 'completed';
export const UTILITY_ACTIVATION_LINK_REQUEST_STATUS_REDIRECTED = 'redirected';

export const UTILITY_ACTIVATION_ITEM_ORDER_TYPE_NON_DELAYED_ORDERS = 'non-delayed-orders';
export const UTILITY_ACTIVATION_ITEM_ORDER_TYPE_DELAYED_ORDERS = 'delayed-orders';
export const UTILITY_ACTIVATION_ITEM_ORDER_TYPE_FAR_OUT_MOVE_INS = 'far-out-move-ins';

export const UTILITY_ACTIVATION_FILE_SOURCE_SPECTRUM_SCRAPER = 'spectrumScraper';
export const UTILITY_ACTIVATION_FILE_SOURCE_COX_SCRAPER = 'coxScraper';
export const UTILITY_ACTIVATION_FILE_SOURCE_ATT_SCRAPER = 'attScraper';
export const UTILITY_ACTIVATION_FILE_SOURCE_XFINITY_SCRAPER = 'xfinityScraper';
export const UTILITY_ACTIVATION_FILE_SOURCE_USER_UPLOAD = 'userUpload';

export const UTILITY_ACTIVATION_FILE_SOURCE_LIST = [
  UTILITY_ACTIVATION_FILE_SOURCE_SPECTRUM_SCRAPER,
  UTILITY_ACTIVATION_FILE_SOURCE_COX_SCRAPER,
  UTILITY_ACTIVATION_FILE_SOURCE_ATT_SCRAPER,
  UTILITY_ACTIVATION_FILE_SOURCE_XFINITY_SCRAPER,
  UTILITY_ACTIVATION_FILE_SOURCE_USER_UPLOAD,
];

export const AUTOMATED_PURCHASE_REQUEST_STATUS_PENDING = 'pending';
export const AUTOMATED_PURCHASE_REQUEST_STATUS_COMPLETED = 'completed';
export const AUTOMATED_PURCHASE_REQUEST_STATUS_FAILED = 'failed';

export const AUTOMATED_PURCHASE_REQUEST_STATUS_LIST = [
  AUTOMATED_PURCHASE_REQUEST_STATUS_PENDING,
  AUTOMATED_PURCHASE_REQUEST_STATUS_COMPLETED,
  AUTOMATED_PURCHASE_REQUEST_STATUS_FAILED,
];

export const AUTOMATED_ORDER_PLACER_TYPE_SPECTRUM = 'spectrumScraper';
export const AUTOMATED_ORDER_PLACER_TYPE_COX = 'coxScraper';
export const AUTOMATED_ORDER_PLACER_TYPE_ATT = 'attScraper';
export const AUTOMATED_ORDER_PLACER_TYPE_XFINITY = 'xfinityScraper';

export const AUTOMATED_ORDER_PLACER_TYPE_LIST = [
  AUTOMATED_ORDER_PLACER_TYPE_SPECTRUM,
  AUTOMATED_ORDER_PLACER_TYPE_COX,
  AUTOMATED_ORDER_PLACER_TYPE_ATT,
  AUTOMATED_ORDER_PLACER_TYPE_XFINITY,
];

export const FILE_PARSER_TYPE_RENT_ROLL = 'rentRoll';
export const FILE_PARSER_TYPE_ADDRESS_IMPORT = 'addressImport';
export const FILE_PARSER_TYPE_INTERNET_DISCOUNT_ELIGIBILITIES = 'internetDiscountEligibilities';
export const FILE_PARSER_TYPE_PROPERTIES_UTILITIES = 'propertiesUtilities';

export const FILE_PARSER_TYPE_LIST = [
  FILE_PARSER_TYPE_RENT_ROLL,
  FILE_PARSER_TYPE_ADDRESS_IMPORT,
  FILE_PARSER_TYPE_INTERNET_DISCOUNT_ELIGIBILITIES,
  FILE_PARSER_TYPE_PROPERTIES_UTILITIES,
];

export const FILE_PARSER_TYPE_OPTIONS = [
  {
    label: 'Rent Roll',
    value: FILE_PARSER_TYPE_RENT_ROLL,
  },
  {
    label: 'Address Import',
    value: FILE_PARSER_TYPE_ADDRESS_IMPORT,
  },
  {
    label: 'Internet Discount Eligibilities',
    value: FILE_PARSER_TYPE_INTERNET_DISCOUNT_ELIGIBILITIES,
  },
  {
    label: 'Properties Utilities',
    value: FILE_PARSER_TYPE_PROPERTIES_UTILITIES,
  },
];

export const UTILITY_TENANT_BULK_IMPORT_SYNC_IMPORT_TYPE_ACTIVE_TENANT_IMPORT =
  'activeTenantImport';
export const UTILITY_TENANT_BULK_IMPORT_SYNC_IMPORT_TYPE_FUTURE_TENANT_IMPORT =
  'futureTenantImport';

export const UTILITY_TENANT_BULK_IMPORT_SYNC_IMPORT_TYPE_LIST = [
  UTILITY_TENANT_BULK_IMPORT_SYNC_IMPORT_TYPE_ACTIVE_TENANT_IMPORT,
  UTILITY_TENANT_BULK_IMPORT_SYNC_IMPORT_TYPE_FUTURE_TENANT_IMPORT,
];

export const PROVIDER_QUESTION_PURCHASE_FLOW_TYPE_RETAIL = 'retail';
export const PROVIDER_QUESTION_PURCHASE_FLOW_TYPE_INTERNET_AMENITY = 'internetAmenity';
export const PROVIDER_QUESTION_PURCHASE_FLOW_TYPE_ALL = 'all';

export const PROVIDER_QUESTION_PURCHASE_FLOW_TYPE_LIST = [
  PROVIDER_QUESTION_PURCHASE_FLOW_TYPE_RETAIL,
  PROVIDER_QUESTION_PURCHASE_FLOW_TYPE_INTERNET_AMENITY,
  PROVIDER_QUESTION_PURCHASE_FLOW_TYPE_ALL,
];

export const UTILITY_PROVIDER_PURCHASE_FLOW_TYPE_RETAIL = 'retail';
export const UTILITY_PROVIDER_PURCHASE_FLOW_TYPE_INTERNET_AMENITY = 'internetAmenity';
export const UTILITY_PROVIDER_PURCHASE_FLOW_TYPE_HYBRID = 'hybrid';

export const UTILITY_ANNOUNCEMENT_TYPE_RENTERS_INSURANCE = 'rentersInsurance';

export const ADDRESS_PREDICTION_PROVIDER_GOOGLE = 'google';
export const ADDRESS_PREDICTION_PROVIDER_SMARTY = 'smarty';
export const ADDRESS_PREDICTION_PROVIDER_LIST = [
  ADDRESS_PREDICTION_PROVIDER_GOOGLE,
  ADDRESS_PREDICTION_PROVIDER_SMARTY,
];

export const ADDRESS_RESOLUTION_STATUS_NO_MATCH = 'no_match';
export const ADDRESS_RESOLUTION_STATUS_INVALID_MATCH = 'invalid_match';
export const ADDRESS_RESOLUTION_STATUS_LIST = [
  ADDRESS_RESOLUTION_STATUS_NO_MATCH,
  ADDRESS_RESOLUTION_STATUS_INVALID_MATCH,
];

export const ADDRESS_RESOLUTION_STATUS_TO_LABEL_MAPPING = {
  [ADDRESS_RESOLUTION_STATUS_NO_MATCH]: 'No Match',
  [ADDRESS_RESOLUTION_STATUS_INVALID_MATCH]: 'Invalid Match',
};

export const ADDRESS_RESOLUTION_RECOVERABLE_SOURCES = [
  PARTNER_ADDRESS_SOURCE_ACTIVE_TENANT_IMPORT,
  PARTNER_ADDRESS_SOURCE_PARTNER,
  PARTNER_ADDRESS_SOURCE_ADMIN,
  PARTNER_ADDRESS_SOURCE_RENT_ROLL,
  PARTNER_ADDRESS_SOURCE_BULK_IMPORT,
  PARTNER_ADDRESS_SOURCE_PMS_SYNC,
];

export const ADDRESS_RESOLUTION_REASON_MANUALLY_LINKED_EXISTING =
  'Manually linked to existing address';
export const ADDRESS_RESOLUTION_REASON_MANUALLY_LINKED_NEW = 'Manually linked to a new address';

/* eslint-disable no-template-curly-in-string */
export const UTILITY_ACTIVATION_ITEM_PURCHASE_REQUEST_TERMS_AND_CONDITIONS =
  '### Internet Service Facilitation by ${utilityPartnerName}:\n\n' +
  'As your property management team, we facilitate access to internet ' +
  'services by connecting you with Internet Service ' +
  'Providers (ISPs). By opting for internet services through our platform, you ("the Renter") agree to ' +
  'these terms and conditions. Understanding these will help you navigate the service setup and any fees ' +
  'or requirements that may apply.\n\n' +
  '### Service Terms and Potential Additional Costs:\n\n' +
  '1. Installation: While professional installation is often free, specific ' +
  'requirements by the Internet Service ' +
  'Provider (ISP) may incur a one-time cost ranging from $25 to $100. ' +
  'These charges will arise as determined ' +
  'by the ISP, without prior notification from us.\n' +
  '2. Equipment Rental: Standard equipment like modems is usually included ' +
  'at no extra charge. However, certain ' +
  'conditions set by the ISP may lead to a monthly rental fee of $5 to $15. You acknowledge and agree to ' +
  'potentially incur these fees directly from the ISP.\n' +
  '3. Credit-Based Adjustments: Should the ISP determine that a pre-payment is necessary based on ' +
  'your credit assessment, you may be required to pay an advanced deposit of $50 to ' +
  '$100. This deposit will be applied as ' +
  "credit to your first bill(s). This fee is governed by the ISP's credit " +
  'policies and will not be pre-disclosed by our management.\n' +
  "4. Prepayment of the First Month's Bill: The ISP may require a prepayment of your first month's " +
  'service fee, ranging from $50 up to $120, due to factors such as credit assessments ' +
  'or prior delinquencies as determined by their policies. This amount will be applied toward ' +
  "your initial billing cycle, serving as your first month's payment rather than an additional fee. " +
  'You acknowledge and agree that you may incur this cost directly ' +
  'from the ISP under their terms and conditions.\n' +
  '5. Shipping Costs: Generally, equipment shipping is free, but certain circumstances ' +
  'may necessitate a one-time ' +
  'shipping fee of $10 to $15. You agree to bear these costs if they apply, as determined by the ISP.\n\n' +
  '### Role of ${utilityPartnerName} and Disclaimer:\n' +
  '${utilityPartnerName} merely facilitates the connection between you and the ISPs. ' +
  'We do not provide internet services ' +
  'directly, nor do we influence the terms, conditions, or the performance of the ' +
  'services provided by ISPs. ' +
  'You agree that ${utilityPartnerName} nor Utility Profit is not liable for any discrepancies, ' +
  'additional costs, or service ' +
  'quality issues that may occur. All obligations related to the internet service ' +
  'provision rest between you, the Renter, and the ISP.\n\n' +
  '### Your Responsibilities:\n\n' +
  'You are responsible for the accuracy and completeness of all information ' +
  'you provide during this process. ' +
  '${utilityPartnerName} nor Utility Profit is not responsible for any delays or alterations in ' +
  'service provisioning resulting ' +
  'from inaccuracies or incomplete information.\n\n' +
  '### Acceptance of Terms:\n\n' +
  'By checking the checkbox below and proceeding with your internet ' +
  'service request, you confirm that you have ' +
  'read, understood, and agree to these terms and conditions. ' +
  'If you do not agree, please do not proceed with your request.';

export const XFINITY_ADDITIONAL_TERMS =
  '## \ud83d\udccc Additional Terms for Xfinity Internet Orders Only\n\n' +
  '_The following terms apply **only** to renters selecting Xfinity as their internet provider. ' +
  'These terms include plan pricing ranges, eligibility requirements, data usage policies, and potential discounts._\n\n' +
  '👉 [Click here to view the Xfinity-specific Terms and Conditions.](https://drive.google.com/file/d/1Dw2HMnROZLBzPLCVns9KV0ZzgQi7ENY-/view?usp=sharing)';
/* eslint-enable no-template-curly-in-string */

/* eslint-disable no-template-curly-in-string */
export const UTILITY_ACTIVATION_ITEM_PURCHASE_REQUEST_TERMS_AND_CONDITIONS_HYBRID_PLANS =
  '### Internet Service Facilitation by ${utilityPartnerName}:\n\n' +
  'As your property management team, we facilitate access to internet ' +
  'services by connecting you with Internet Service ' +
  'Providers (ISPs) via Utility Wallet. By opting for internet services through the platform, you ("the Renter") agree to ' +
  'these terms and conditions. Understanding these will help you navigate the service setup, monthly auto-pay details and any fees ' +
  'or requirements that may apply.\n\n' +
  '### Service Terms and Potential Additional Costs:\n\n' +
  '1. Auto-pay enrollment: Enrollment is required to receive the discounted pricing shown during plan selection. ' +
  'By enrolling in auto-pay, your payments will be automatically deducted from your designated account monthly. ' +
  'If you choose not to enroll in auto-pay, you will not be eligible for the discounted pricing for the plan and provider you selected. ' +
  'Instead, you may select an alternate plan at the standard (non-discounted) rate.\n' +
  '2. Billing and Payment: Automatic Billing is handled directly by Utility Wallet via Stripe. ' +
  'You will receive paperless billing at the email address provided during sign-up. ' +
  'To update your designated account for automatic payments please email us at reminders@utility-setup.com.\n' +
  '3. Installation fees and availability of installation options are subject to the policies of the selected Internet Service Provider ("ISP"). The following terms apply:\n' +
  '\n a. Self-Installation: Self-installation may be offered at no additional cost.\n' +
  '\n b. Professional Installation: Professional installation may be available for an additional fee, which is determined by the ISP. As of the date of these terms, Astound charges ' +
  'a one-time fee of $80.00 for professional installation. Certain providers may waive this fee based on promotional eligibility, service plans, or other factors.\n' +
  '4. Equipment Rental: Standard equipment like modems will be included at no extra charge.\n' +
  '5. Shipping Costs: Equipment shipping is free.\n' +
  '6. Return of Equipment Rental: Upon the end of your internet plan you will need to return your equipment ' +
  'to the provider via Fedex or UPS free of charge. Should you not return your equipment in a timely manner ' +
  'automatic charges will incur ranging from $30 up to $200 depending on the equipment. ' +
  'You agree to bear these costs if they apply, as determined by the ISP.\n\n' +
  '### Role of ${utilityPartnerName} and Disclaimer:\n' +
  '${utilityPartnerName} merely facilitates the connection between you and the ISPs via Utility Wallet. ' +
  'We do not provide internet services ' +
  'directly, nor do we influence the terms, conditions, or the performance of the ' +
  'services provided by ISPs. ' +
  'You agree that ${utilityPartnerName} is not liable for any discrepancies, ' +
  'additional costs, or service ' +
  'quality issues that may occur. All obligations related to the internet service ' +
  'provision rest between you, the Renter, and the ISP.\n\n' +
  '### Your Responsibilities:\n\n' +
  'You are responsible for the accuracy and completeness of all information ' +
  'you provide during this process. ' +
  '${utilityPartnerName} nor Utility Wallet is not responsible for any delays or alterations in ' +
  'service provisioning resulting ' +
  'from inaccuracies or incomplete information.\n\n' +
  '### Acceptance of Terms:\n\n' +
  'By checking the checkbox below and proceeding with your internet ' +
  'service request, you confirm that you have ' +
  'read, understood, and agree to these terms and conditions. ' +
  'If you do not agree, please do not proceed with your request.';
/* eslint-enable no-template-curly-in-string */

// OnSwitch availability status values (from lib/shared/src/onswitch.enums.ts)
export const ON_SWITCH_AVAILABILITY_STATUS_AVAILABLE = 'available';
export const ON_SWITCH_AVAILABILITY_STATUS_GENERIC = 'generic';
export const ON_SWITCH_AVAILABILITY_STATUS_NON_AVAILABLE = 'non_available';

// OnSwitch workflow run statuses (from backend)
export const ON_SWITCH_WORKFLOW_RUN_STATUS_PENDING = 'pending';
export const ON_SWITCH_WORKFLOW_RUN_STATUS_RUNNING = 'running';
export const ON_SWITCH_WORKFLOW_RUN_STATUS_COMPLETED = 'completed';
export const ON_SWITCH_WORKFLOW_RUN_STATUS_FAILED = 'failed';
export const ON_SWITCH_WORKFLOW_RUN_STATUS_CANCELLED = 'cancelled';
export const ON_SWITCH_WORKFLOW_RUN_STATUS_NO_RUN = 'no_run';

export const ON_SWITCH_WORKFLOW_RUN_STATUS_LABEL_MAPPING = {
  [ON_SWITCH_WORKFLOW_RUN_STATUS_NO_RUN]: 'No Run',
  [ON_SWITCH_WORKFLOW_RUN_STATUS_PENDING]: 'Pending Run',
  [ON_SWITCH_WORKFLOW_RUN_STATUS_RUNNING]: 'Running',
  [ON_SWITCH_WORKFLOW_RUN_STATUS_COMPLETED]: 'Completed Run',
  [ON_SWITCH_WORKFLOW_RUN_STATUS_FAILED]: 'Failed',
  [ON_SWITCH_WORKFLOW_RUN_STATUS_CANCELLED]: 'Cancelled',
};

// Liability Waiver (Insurance)
export const TENANT_LIABILITY_PRICE_UPCHARGE_DOLLARS = 4;
